<template>
  <master-layout
    smallTitle="clienti  assegnati"
    bigTitle=" da yoUBe"
    :showInfoPopHover="true"
    :infoPopHover="
      whappyClientConfig.name == 'Yoube'
        ? INFOPOPOVER_MAP[whappyClientConfig.name]
        : INFOPOPOVER_MAP['default']
    "
  >
    <ion-grid class="main-container">
      <!-- <ion-row
        class="items ion-padding-horizontal ion-margin-bottom"
        v-for="item of filteredItems"
        :key="item.id"
        @click="openModalActualClient(item)"
      > -->
      <ion-row
        class="items ion-padding-horizontal ion-margin-bottom ion-padding-top"
        v-for="item of filteredItems"
        :key="item.id"
        @click="gotoDettagliCliente(item)"
      >
        <ion-col>
          <ion-row> {{ item.nome }} {{ item.cognome }} </ion-row>
          <ion-row>
            <span class="font-bold"> {{ item.ragioneSociale }} </span>
          </ion-row>
        </ion-col>
        <ion-col class="ion-text-end" size="2">
          <ion-icon :icon="call"></ion-icon>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-row class="cta ion-justify-content-center"
      ><ion-col size="auto">
        <button
          :disabled="loadingMoreResults"
          type="button"
          class="p-d button-primary"
          @click="askForMoreResults"
        >
          {{ loadingMoreResults ? "Caricamento..." : "Carica più risultati" }}
        </button>
      </ion-col>
    </ion-row>
  </master-layout>
</template>

<script>
import {
  modalController,
  IonButton,
  IonFooter,
  IonToolbar,
  IonSearchbar,
  IonCol,
  IonGrid,
  IonRow,
  IonIcon,
} from "@ionic/vue"
import { call } from "ionicons/icons"
import ModalActualClient from "./Modals/ModalActualClient.vue"
import GradientProgressBar from "@/components/GradientProgressBar.vue"
import ApiService from "../common/service.api"
export default {
  name: "AnagraficaClientiAssegnati",
  components: {
    IonButton,
    IonFooter,
    IonToolbar,
    IonSearchbar,
    IonCol,
    IonGrid,
    IonRow,
    IonIcon,
    GradientProgressBar,
  },
  data() {
    return {
      call,
      filter: "",
      items: [],

      idUtente: 0,
      INFOPOPOVER_MAP: {
        Yoube: "Una lista di possibili clienti da contattare.",
        default: "Una lista di possibili clienti da contattare.",
      },
      currentResults: 0,
      loadingMoreResults: false,
    }
  },
  created() {
    this.$store.state.user.userData
      ? (this.idUtente = this.$store.state.user.userData.data.id)
      : console.error("user not found")

    this.getData()
  },
  methods: {
    getData() {
      ApiService.post("Ecommerce/GetAnags", {
        take: 10,
        skip: this.currentResults,
      })
        .then((res) => {
          this.items = res.data
        })
        .finally(() => {
          this.currentResults = this.items.length
        })
    },
    askForMoreResults() {
      const endpoint = "Ecommerce/GetAnags"
      const queryParams = {
        take: 10,
        skip: this.currentResults,
      }

      this.loadingMoreResults = true

      ApiService.post(endpoint, queryParams)
        .then((response) => {
          this.items = this.items.concat(response.data)
        })
        .finally(() => {
          this.currentResults = this.items.length
          this.loadingMoreResults = false
        })
    },
    gotoDettagliCliente(cliente) {
      console.log(
        "🚀 ~ file: AnagraficaClienti.vue:152 ~ gotoDettagliCliente ~ cliente:",
        cliente
      )

      this.$router.push({
        name: "DettagliCliente",
        params: {
          idCliente: cliente.id,
        },
      })
    },
    async openModalActualClient(item) {
      const modal = await modalController.create({
        component: ModalActualClient,
        cssClass: "my-custom-class",
        componentProps: { client: item },
      })

      return modal.present()
    },
  },
  computed: {
    filteredItems() {
      if (this.filter) {
        return this.items.filter((azienda) => {
          return (
            azienda.nome.toLowerCase().includes(this.filter.toLowerCase()) ||
            azienda.ragioneSociale
              .toLowerCase()
              .includes(this.filter.toLowerCase()) ||
            azienda.cognome.toLowerCase().includes(this.filter.toLowerCase())
          )
        })
      } else {
        return this.items
      }
    },
  },
}
</script>

<style scoped>
/* * {
  border: 1px solid purple;
} */

/* .cta {
  padding: 2rem 0;
}

.cta ion-button {
  height: 4rem;
} */

h3 {
  font-weight: bolder;
}
</style>
